import type { SessionStepDto } from '../schemas/sessionSchemas';
import { aadhaarStepModule } from './aadhaar';
import { bankStepModule } from './bank';
import { emailStepModule } from './email';
import { faceStepModule } from './face';
import { gstStepModule } from './gst';
import { idStepModule } from './id';
import { livenessStepModule } from './liveness';
import { msmeStepModule } from './msme';
import { panStepModule } from './pan';
import { questionnaireStepModule } from './questionnaire';
import { rationStepModule } from './ration';
import { templateStepModule } from './template';
import { esignTemplateStepModule } from './template/esignModule';
import type { SessionStepModule } from './types';
import { utilityStepModule } from './utility';

// All verification step modules. Add a new category's module here (and create
// its folder under steps/<api>/) — the session panels pick the right one via
// resolveStepModule, so no panel changes are needed to support a new API flow.
const SESSION_STEP_MODULES: SessionStepModule[] = [
  panStepModule,
  aadhaarStepModule,
  faceStepModule,
  livenessStepModule,
  bankStepModule,
  gstStepModule,
  idStepModule,
  utilityStepModule,
  rationStepModule,
  msmeStepModule,
  templateStepModule,
  esignTemplateStepModule,
  questionnaireStepModule,
  emailStepModule,
];

// The module for a step, or null when the step type isn't implemented yet
// (the panels fall back to the "coming soon" placeholder).
export function resolveStepModule(step: SessionStepDto): SessionStepModule | null {
  return SESSION_STEP_MODULES.find((m) => m.matches(step)) ?? null;
}
